import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgVisa({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.046 15.16l1.008-6.255h1.611l-1.008 6.254H9.046zM16.503 9.058a3.983 3.983 0 00-1.444-.262c-1.594 0-2.715.849-2.724 2.064-.01.899.8 1.4 1.41 1.699.629.306.84.502.837.776-.004.419-.5.61-.964.61-.645 0-.988-.094-1.518-.327l-.207-.1-.226 1.4c.376.174 1.073.325 1.796.333 1.693 0 2.793-.838 2.806-2.136.006-.713-.424-1.253-1.354-1.699-.563-.29-.908-.482-.904-.776 0-.26.291-.538.923-.538.527-.008.908.113 1.206.24l.144.072.219-1.356zM18.648 12.942c.134-.36.642-1.748.642-1.748-.01.016.133-.363.215-.597l.108.54s.31 1.492.373 1.805h-1.338zm1.988-4.03h-1.245c-.386 0-.675.11-.845.518l-2.393 5.731h1.693s.276-.77.339-.94l2.064.003c.048.219.196.937.196.937h1.495l-1.304-6.25zM7.694 8.91l-1.577 4.264-.17-.867c-.293-.998-1.208-2.08-2.231-2.623l1.443 5.47 1.705-.002L9.402 8.91H7.694z"
        fill="#26337A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.653 8.906H2.054l-.021.13c2.022.517 3.36 1.768 3.915 3.27l-.565-2.873c-.097-.396-.38-.513-.73-.527z"
        fill="#EC982D"
      />
    </svg>
  )
}

export default SvgVisa
